var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "tile h-100" }, [
    _c(
      "div",
      {
        staticClass: "container h-100 mw-100 border-2",
        class: _vm.isSelected ? "selected-tile" : "",
      },
      [
        _c("div", { staticClass: "row bg-white" }, [
          _c(
            "div",
            {
              staticClass: "col-12 bg-header-tile",
              style:
                "background-image: url(" + _vm.offer.backgroundImage + ");",
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm.offer.banner
                  ? _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "tag-timer" }, [
                        _c("div", { staticClass: "row align-items-center" }, [
                          _c("div", { staticClass: "col-auto p-0" }, [
                            _c(
                              "div",
                              { staticClass: "ob1-tag ob1-tag-primary" },
                              [_c("span", [_vm._v(_vm._s(_vm.offer.banner))])]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.offer.timerEndDateInMilliseconds
                            ? _c(
                                "div",
                                { staticClass: "col-auto" },
                                [
                                  _c("timer", {
                                    attrs: {
                                      "end-date-in-milliseconds":
                                        _vm.offer.timerEndDateInMilliseconds,
                                      color: _vm.offer.countDownColor
                                        ? _vm.offer.countDownColor
                                        : "text-dark",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ])
                  : _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "tag-timer" }),
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-7 pe-0 pt-1" }, [
                  _c("div", [
                    _vm.offer.hideShortLabel
                      ? _c("div", { staticClass: "title-align" }, [
                          _c("div", { staticClass: "h4 pb-0 mb-1" }, [
                            _c("span", { staticClass: "visually-hidden" }, [
                              _vm._v(_vm._s(_vm.offer.name)),
                            ]),
                          ]),
                        ])
                      : _c("div", { staticClass: "title-align" }, [
                          _c("h2", {
                            staticClass: "h4 pb-0 mb-1",
                            class: _vm.offer.shortLabelColor
                              ? _vm.offer.shortLabelColor
                              : "",
                            domProps: { innerHTML: _vm._s(_vm.offerHtmlName) },
                          }),
                        ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("p", { staticClass: "small fw-bold mb-0 pb-0" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.offer.priceConnectedTitle) +
                            "\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("Price", {
                        staticClass: "price-align",
                        attrs: {
                          price: _vm.offer.price.price,
                          "initial-price": _vm.offer.price.initialPrice,
                          "price-details": _vm.offer.price.priceDetails
                            ? _vm.offer.price.priceDetails
                            : undefined,
                          "show-from": _vm.offer.price.showFrom,
                          "show-by-month": _vm.offer.price.showByMonth,
                          "show-promo-duration":
                            _vm.offer.price.showPromoDuration,
                          "show-end-of-promotion-price":
                            _vm.offer.price.showEndOfPromotionPrice,
                          duration: _vm.offer.price.duration,
                          "is-cents-format": false,
                          "is-compact": _vm.offer.price.compact,
                          custom: _vm.priceCustomClasses,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-5 px-0 pt-1 text-center" }, [
                  _vm.offer.visualUrl
                    ? _c("div", [
                        _c("img", {
                          staticStyle: { "max-width": "130px" },
                          attrs: {
                            width: "100%",
                            alt: _vm.offer.visualAlt,
                            src: _vm.offer.visualUrl,
                          },
                        }),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "mobileprice-odrmention-align" }, [
                    _vm.offer.mobileDiscountedPrice
                      ? _c("div", { staticClass: "bg-greige p-1 mb-0" }, [
                          _c("p", { staticClass: "small m-0 p-0" }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.offer.mobileDiscountedPriceTitle)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "small m-0 p-0" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.offer.mobileDiscountedPrice.price) +
                                  "/mois"
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.offer.mobileDiscountedPrice.duration > 0
                              ? _c("span", [
                                  _vm._v(
                                    "pendant " +
                                      _vm._s(
                                        _vm.offer.mobileDiscountedPrice.duration
                                      ) +
                                      " mois puis "
                                  ),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.offer.mobileDiscountedPrice
                                          .initialPrice
                                      ) + "/mois"
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.offer.permanentOdrMentionBlock
                      ? _c("div", { staticClass: "bg-greige p-1 mb-0" }, [
                          _c("p", {
                            staticClass: "small m-0 p-0",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.offer.permanentOdrMentionBlock.odrTitle
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "small m-0 p-0",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.offer.permanentOdrMentionBlock
                                  .odrDescription
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "detail-link-align" }, [
                    _vm.showDetailPage &&
                    _vm.detailPageUrl &&
                    _vm.showDetailPageBtnLabel
                      ? _c(
                          "a",
                          {
                            staticClass: "ob1-link-arrow",
                            attrs: {
                              id: "discover-offer-link-" + _vm.offerTileIndex,
                              href: _vm.detailPageUrl,
                              "data-oevent-action":
                                _vm.offer.showOfferDetailPageBtnTms.action,
                              "data-oevent-category":
                                _vm.offer.showOfferDetailPageBtnTms.category,
                              "data-oevent-label":
                                _vm.offer.showOfferDetailPageBtnTms.label,
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.showDetailPageBtnLabel) +
                                "\n                            "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 pb-2" }, [
            _c("div", { staticClass: "pt-1 text-center" }, [
              _vm.offer.genericButtonCta
                ? _c(
                    "div",
                    [
                      _c("generic-button-cta", {
                        attrs: {
                          "dto-from-object": _vm.offer.genericButtonCta,
                          "css-classes": "btn-primary w-100 mw-100",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.comparatorCta
              ? _c(
                  "div",
                  { staticClass: "pt-1 text-center" },
                  [
                    _c("generic-button-cta", {
                      attrs: {
                        "dto-from-object": _vm.comparatorCta,
                        "css-classes": "btn-secondary w-100 mw-100",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.offer.genericButtonCta && _vm.offer.selectButton
              ? _c("div", [
                  _vm.isSelected
                    ? _c("div", { staticClass: "internet-selection h-100" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "mb-0 d-flex border-top-bottom-2 align-items-center justify-content-center h-100",
                          },
                          [
                            _c("span", {
                              staticClass: "icon icon-tick-circle",
                              staticStyle: { "font-size": "1.5rem" },
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "lead fw-bold ms-1" }, [
                              _vm._v(_vm._s(_vm.buttonLabel)),
                            ]),
                          ]
                        ),
                      ])
                    : _c("div", { staticClass: "internet-selection" }, [
                        _c(
                          "button",
                          {
                            staticClass: "px-1 px-lg-2 btn btn-secondary w-100",
                            attrs: {
                              type: "button",
                              "data-oevent-category":
                                _vm.offer.selectButtonTms.category,
                              "data-oevent-action":
                                _vm.offer.selectButtonTms.action,
                              "data-oevent-label":
                                _vm.offer.selectButtonTms.label,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onSelectOffer()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.buttonLabel) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row bg-white" }, [
          _c(
            "div",
            {
              staticClass: "offer-edito-content col-12",
              attrs: {
                "data-oevent-category": _vm.offer.popinTmsDTO.category,
                "data-oevent-label": _vm.offer.popinTmsDTO.label,
              },
            },
            _vm._l(_vm.offer.attributes, function (attribute, index) {
              return _c("div", { key: index }, [
                attribute.hasTopSeparator
                  ? _c("div", { staticClass: "col-12" }, [
                      _c("hr", { staticClass: "my-0" }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex mb-1" }, [
                  attribute.image
                    ? _c(
                        "div",
                        { staticClass: "offer-tile-attribute-image me-1" },
                        [
                          _c("span", {
                            staticClass: "icon lead text-primary",
                            class: attribute.image,
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", {
                      class: ["font-size-14 media-body-description-" + index],
                      domProps: { innerHTML: _vm._s(attribute.description) },
                    }),
                    _vm._v(" "),
                    attribute.tag
                      ? _c("strong", {
                          staticClass: "ob1-tag ob1-tag-small ob1-tag-specific",
                          domProps: { innerHTML: _vm._s(attribute.tag) },
                        })
                      : _vm._e(),
                  ]),
                ]),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.offer.claims, function (visualClaim) {
            return _c("div", { key: visualClaim.id, staticClass: "row" }, [
              _c("div", { staticClass: "col-12 py-1 visual-claim-bg" }, [
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", { staticClass: "pe-1" }, [
                    _c("span", {
                      staticClass: "icon h4 mb-0",
                      class: _vm.offer.visualClaimsIcon,
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    _vm._l(visualClaim.attributes, function (attribute) {
                      return _c("div", { key: attribute.id }, [
                        attribute.title
                          ? _c("p", {
                              staticClass: "fw-bold py-0 mb-0",
                              domProps: { innerHTML: _vm._s(attribute.title) },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        attribute.textHtml
                          ? _c("p", {
                              staticClass: "py-0 mb-0",
                              domProps: {
                                innerHTML: _vm._s(attribute.textHtml),
                              },
                            })
                          : _vm._e(),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
              _vm._v(" "),
              visualClaim.visuals
                ? _c(
                    "div",
                    { staticClass: "col-12 px-0 visual-claim-border bg-white" },
                    [
                      _c("div", { staticClass: "text-center" }, [
                        _c(
                          "div",
                          {
                            staticClass: "row justify-content-center px-1 pt-1",
                          },
                          _vm._l(visualClaim.visuals, function (visual) {
                            return _c(
                              "div",
                              {
                                key: visual.id,
                                staticClass: "col-4 px-1 pb-1",
                              },
                              [
                                _c("img", {
                                  staticClass: "visual-claim-img",
                                  attrs: {
                                    loading: "lazy",
                                    src: visual.url,
                                    alt: visual.alt,
                                  },
                                }),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ])
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }